import { render, staticRenderFns } from "./Predeterminado.vue?vue&type=template&id=ea34a478&"
import script from "./Predeterminado.vue?vue&type=script&lang=js&"
export * from "./Predeterminado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports